const sinusitis_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"F[0].Page_1[0].Public2507Questions[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"F[0].Page_1[0].Public2507Questions[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_1[0].Public2507Questions[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "maxLength":105,
      "radioGroup":"F[0].Page_1[0].PublicEvidenceReview[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"F[0].Page_1[0].PublicEvidenceReview[0].IdentifyEvidence[0]",
      "textanswer":""
   },

   {
      "question":"Indicate the sinuses/type of sinusitis currently affected by ##name##'s Chronic sinusitis",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "partial": true,
      "section": {
         page: "3",
         title: "SINUSITIS",
         number: "A1"
      },
     "textarea": false,
      "small": true, //incase without textarea show tile
      "cols": 2,
      "questions":[
         {
            "main":"None",
            "dbqName":"F[0].Page_3[0].B1_3[0]",
            "partialField": true,
            "answer":"",
         },
         {
            "main":"Maxillary",
            "dbqName":"F[0].Page_3[0].B2_3[0]",
            "answer":"",
         },
         {
            "main":"Frontal",
            "dbqName":"F[0].Page_3[0].B3_3[0]",
            "answer":"",
         },
         {
            "main":"Ethmoid",
            "dbqName":"F[0].Page_3[0].B4_3[0]",
            "answer":"",
         },
         {
            "main":"Sphenoid",
            "dbqName":"F[0].Page_3[0].B5_3[0]",
            "answer":"",
         },
         {
            "main":"Pansinusitis",
            "dbqName":"F[0].Page_3[0].B6_3[0]",
            "answer":"",
         }
      ],
      "answer":"",
      "textAnswer": ""
   },

   {
      "question":"Does ##name## currently have any findings,  signs or symptoms attribute to Chronic sinusitis?",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "section": {
         page: "3",
         title: "SINUSITIS",
         number: "A2"
      },
     "textarea": false,
      "small": true, //incase without textarea show tile
      "cols": 2,
      "questions":[
         {
            "main":"Near constant sinusitis (Describe Frequency)",
            "dbqName":"F[0].Page_3[0].C3[0],F[0].Page_3[0].Yes3C[0]",
            "answer":"",
            "textarea": true,
            "maxLength":50,
            "textdbqName" : "F[0].Page_3[0].DescribeOther[1]",
            "placeholder": "Please describe",
            "textAnswer": ""
         },
         {
            "main":"Headaches",
            "dbqName":"F[0].Page_3[0].C4[0],F[0].Page_3[0].Yes3C[0]",
            "answer":"",
         },
         {
            "main":"Pain of affected sinus",
            "dbqName":"F[0].Page_3[0].C5[0],F[0].Page_3[0].Yes3C[0]",
            "answer":"",
         },
         {
            "main":"Tenderness of affected sinus",
            "dbqName":"F[0].Page_3[0].C6[2],F[0].Page_3[0].Yes3C[0]",
            "answer":"",
         },
         {
            "main":"Purulent discharge or crusting",
            "dbqName":"F[0].Page_3[0].C6[0],F[0].Page_3[0].Yes3C[0]",
            "answer":"",
         },
         {
            "main":"Crusting",
            "dbqName":"F[0].Page_3[0].C6[1],F[0].Page_3[0].Yes3C[0]",
            "answer":"",
         },
         {
            "main":"Other",
            "dbqName":"F[0].Page_3[0].C7[0],F[0].Page_3[0].Yes3C[0]",
            "answer":"",
            "textarea": true,
            "maxLength":70,
            "textdbqName" : "F[0].Page_3[0].DescribeOther[0]",
            "placeholder": "Please describe",
            "textAnswer": ""
         },
      ],
      "answer":"",
      "textAnswer": ""
   },
   {
      "question":"Number of non-incapacitating episodes over the past 12 months",
      "sub":"",
      "type":"radio",
      "show": true,
      "multi": true,
      "section": {
         page: "3",
         title: "SINUSITIS",
         number: "A3"
      },
      // "refId":1,
      "questions":[
         {
            "label":"Non-Incapacitating Episodes",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"1 episode",
                  "dbqName":"F[0].Page_3[0].One[0],F[0].Page_3[0].Yes3D[0]",
                  "sub":""
               },
               {
                  "main":"2 episodes",
                  "dbqName":"F[0].Page_3[0].Two[0],F[0].Page_3[0].Yes3D[0]",
                  "sub":""
               },
               {
                  "main":"3 episodes",
                  "dbqName":"F[0].Page_3[0].Three[0],F[0].Page_3[0].Yes3D[0]",
                  "sub":""
               },
               {
                  "main":"4 episodes",
                  "dbqName":"F[0].Page_3[0].Four[0],F[0].Page_3[0].Yes3D[0]",
                  "sub":""
               },
               {
                  "main":"5 episodes",
                  "dbqName":"F[0].Page_3[0].Five[0],F[0].Page_3[0].Yes3D[0]",
                  "sub":""
               },
               {
                  "main":"6 episodes",
                  "dbqName":"F[0].Page_3[0].Six[0],F[0].Page_3[0].Yes3D[0]",
                  "sub":""
               },
               {
                  "main":"7 or more episodes",
                  "dbqName":"F[0].Page_3[0].Seven[0],F[0].Page_3[0].Yes3D[0]",
                  "sub":""
               }
            ],
            "answer":""
         }
      ]
   },
   {
      "question":"Has ##name## had Incapacitating of Sinusitis required prolonged (4 to 6 weeks) of antibiotics treatment in the past 12 months?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "SINUSITIS",
         number: "A4"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].Page_3[0].Yes3E[0]",
      "dbqName_no":"F[0].Page_3[0].No3E[0]",
      "answer":"",
   },
   {
      "question":"Number of incapacitating episodes of sinusitis requiring prolonged (4 to 6 weeks) of antibiotic treatment over the past 12 months)",
      "sub":"",
      "type":"radio",
      "show": false,
      "refId":1,
      "section": {
         page: "3",
         title: "SINUSITIS",
         number: "A4"
      },
      "questions":[
         {
            "label":"Non-Incapacitating Episodes",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"1 episode",
                  "dbqName":"F[0].Page_3[0].One1[0]",
                  "sub":""
               },
               {
                  "main":"2 episodes",
                  "dbqName":"F[0].Page_3[0].Two1[0]",
                  "sub":""
               },
               {
                  "main":"3 or more episodes",
                  "dbqName":"F[0].Page_3[0].Three1[0]",
                  "sub":""
               }
            ],
            "answer":""
         }
      ]
   },

   {
      "question":"Has ##name## had sinus surgery?",
      "sub":"",
      "type":"radioModal",
      "multi": false,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "3",
         title: "SINUSITIS",
         number: "A5"
      },
      "questions":[
               {
                  "main":"No",
                  "dbqName":"F[0].Page_3[0].No3F[0]",
                  "answer":"",
               },
               {
                  "main":"Yes",
                  "dbqName":"F[0].Page_3[0].Yes3F[0]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "text1": "",
                  "dbqName1": "F[0].Page_3[0].Describe[1]",
                  "placeholder1":"Type of surgery",
                  "date1": "",
                  "dbqDate1": "F[0].Page_3[0].Describe[2]",
                  "placeholderDate1":"Date for Surgery",
                  "subItems": [
                     {
                        "main":"Radical",
                        "dbqName":"F[0].Page_3[0].Type[0]",
                        "colWidth": 4,
                        "answer":""
                     },
                     {
                        "main":"Endoscopic",
                        "dbqName":"F[0].Page_3[0].Type[1]",
                        "colWidth": 4,
                        "answer":""
                     },
                     {
                        "main":"Other",
                        "dbqName":"F[0].Page_3[0].Type[2]",
                        "colWidth": 4,
                        "subItemLinked": true,
                        "answer":""
                     }
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Types of Surgery",
                  "subItemOther": false,
                  "textOther": "",
                  "dbqNameOther": "F[0].Page_3[0].Describe[0]",
                  "placeholderOther":"Other residuals describe",
               }                      
            ],
            "answer":""
   },
   {
      "question":"Has ##name## had radical sinus surgery, did chronic osteomyelitis follow the surgery?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "SINUSITIS",
         number: "A6"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"F[0].Page_3[0].Yes3F1[0]",
      "dbqName_no":"F[0].Page_3[0].No3F1[0]",
      "answer":"",
   },
   {
      "question":"Has ##name## had repeated sinus-related surgical procedures performed?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "SINUSITIS",
         number: "A7"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"F[0].Page_3[0].Yes3F1[1]",
      "dbqName_no":"F[0].Page_3[0].No3F1[1]",
      "answer":"",
   },

   {
      "question":"Is there greater than 50% obstruction of the nasal passage on both sides due to rhinitis?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "RHINITIS",
         number: "B1"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"F[0].Page_3[0].Yes4B[0]",
      "dbqName_no":"F[0].Page_3[0].No4B[0]",
      "answer":"",
   },
   {
      "question":"Is there complete obstruction on the left side due to rhinitis?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "RHINITIS",
         number: "B2"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"F[0].Page_3[0].YES4C[0]",
      "dbqName_no":"F[0].Page_3[0].NO4C[0]",
      "answer":"",
   },
   {
      "question":"Is there complete obstruction on the right side due to rhinitis?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "RHINITIS",
         number: "B3"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"F[0].Page_3[0].YES4C[1]",
      "dbqName_no":"F[0].Page_3[0].NO4C[1]",
      "answer":"",
   },
   {
      "question":"Is there permanent hypertrophy of the nasal turbinates?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "4",
         title: "RHINITIS",
         number: "B4"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"F[0].Page_4[0].Yes4D[0]",
      "dbqName_no":"F[0].Page_4[0].No4D[0]",
      "answer":"",
   },
   {
      "question":"Are there nasal polyps?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "4",
         title: "RHINITIS",
         number: "B5"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"F[0].Page_4[0].YES4E[0]",
      "dbqName_no":"F[0].Page_4[0].NO4E[0]",
      "answer":"",
   },
   {
      "question":"Does the veteran have any of the following granulomatous conditions?",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "partial": true,
      "section": {
         page: "4",
         title: "RHINITIS",
         number: "B6"
      },
     "textarea": false,
      "small": true, //incase without textarea show tile
      "cols": 2,
      "questions":[
         {
            "main":"Granulomatous rhinitis",
            "dbqName":"F[0].Page_4[0].F1[0],F[0].Page_4[0].Yes4F[0]",
            "answer":"",
         },
         {
            "main":"Rhinoscleroma",
            "dbqName":"F[0].Page_4[0].F2[0],F[0].Page_4[0].Yes4F[0]",
            "answer":"",
         },
         {
            "main":"Wegener's granulomatosis",
            "dbqName":"F[0].Page_4[0].F3[0],F[0].Page_4[0].Yes4F[0]",
            "answer":"",
         },
         {
            "main":"Lethal midline granuloma",
            "dbqName":"F[0].Page_4[0].F4[0],F[0].Page_4[0].Yes4F[0]",
            "answer":"",
         },
         {
            "main":"Other granulomatous infection",
            "dbqName":"F[0].Page_4[0].F5[0],F[0].Page_4[0].Yes4F[0]",
            "answer":"",
            "textarea": true,
            "maxLength":58,
            "textdbqName" : "F[0].Page_4[0].DESCRIBE[0]",
            "placeholder": "Please describe",
            "textAnswer": ""
         },
         {
            "main":"None",
            "partialField": true,
            "dbqName":"F[0].Page_4[0].No4F[0]",
            "answer":"",
         },
      ],
      "answer":"",
      "textAnswer": ""
   },
   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "maxLength":710,
      "show": true,
      "section": {
         page: "8",
         title: "REMARKS",
         number: "5B"
      },
      "dbqName":"F[0].Page_8[0].REMARKSIfany[0]",
      "answer":""
   }
 ]

 export default sinusitis_questions ;
